import { gql } from '@parkchirp/api-client';

export const LIST_SURCHARGE_ASSIGNMENTS = gql`
  query listSurchargeAssignments(
    $order: SortOrder
    $filters: [Filter]
    $limit: Int
    $offset: Int
    $report: String
  ) {
    listSurchargeAssignments(
      order: $order
      filters: $filters
      limit: $limit
      offset: $offset
      report: $report
    ) {
      data {
        id
        facilityId
        facilityName
        facilityNumber
        organizationId
        feeId
        feeName
        vehicleTypeId
        vehicleTypeName
        type
      }
      total
      url
    }
  }
`;
